module.exports = __webpack_public_path__ + "img/music.c4810d8e.jpg";